import { Organization } from '@models/Organization';
import { useMemo, useState } from 'react';

interface UseOrganizationSelectorModalViewModelProps {
    organizations: Organization[];
    selectedOrganization?: Organization;
    onClose: () => void;
    onOrganizationSelected: (organization: Organization) => void;
}

export const useOrganizationSelectorModalViewModel = ({
    organizations,
    selectedOrganization,
    onClose,
    onOrganizationSelected
}: UseOrganizationSelectorModalViewModelProps) => {
    const [searchQuery, setSearchQuery] = useState('');

    const normalizedQuery = searchQuery.trim().toLowerCase();
    const rows = useMemo(() => {
        const safeOrganizations = organizations ?? [];

        if (!normalizedQuery) {
            return safeOrganizations;
        }

        return safeOrganizations.filter((organization) => {
            return (
                organization.id.toLowerCase().includes(normalizedQuery) ||
                organization.name.toLowerCase().includes(normalizedQuery)
            );
        });
    }, [organizations, normalizedQuery]);

    const isSelected = (organization: Organization) => {
        return selectedOrganization?.id === organization.id;
    };

    const selectOrganization = (organization: Organization) => {
        onOrganizationSelected(organization);
        onClose();
    };

    return {
        searchQuery,
        setSearchQuery,
        rows,
        isSelected,
        selectOrganization
    };
};
